import { render } from "./CaptionsComponent.vue?vue&type=template&id=e858aaf8"
import script from "./CaptionsComponent.vue?vue&type=script&lang=ts"
export * from "./CaptionsComponent.vue?vue&type=script&lang=ts"
script.render = render

export default script